import Head from 'next/head'

const Keywords = ({ keywords }: { keywords: any[] }): JSX.Element => {
  return (
    <Head>
      <meta
        name="keywords"
        content={keywords.map((keyword) => keyword.toString()).join(', ')}
      />
    </Head>
  )
}

export default Keywords
